export default "__VITE_ASSET__CYXCVOiz__"